"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageServerClient = void 0;

var _BaseDataService2 = require("../../core/BaseDataService");

var _consts = require("../../core/consts");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/**
 * This class provides access to call various ImageServer APIs, excluding images.
 */
var ImageServerClient =
/*#__PURE__*/
function (_BaseDataService) {
  _inherits(ImageServerClient, _BaseDataService);

  function ImageServerClient(httpProvider) {
    var _this;

    var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _consts.DEFAULT_IMAGESERVER_URL;

    _classCallCheck(this, ImageServerClient);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ImageServerClient).call(this));
    Object.assign(_assertThisInitialized(_assertThisInitialized(_this)), {
      get _httpProvider() {
        return httpProvider;
      },

      get baseUrl() {
        return baseUrl;
      }

    });
    return _this;
  } // By default only support "unauthenticated" mode. Auth provider overrides this method in auth mode. Really bad design
  // but I'm not able to contrive a better one.


  _createClass(ImageServerClient, [{
    key: "getPathTo",
    value: function getPathTo(_ref) {
      var path = _ref.path,
          id = _ref.id;
      return path;
    }
  }, {
    key: "getUrlTo",
    value: function getUrlTo(_ref2) {
      var path = _ref2.path,
          id = _ref2.id;
      return "".concat(this.baseUrl, "/").concat(this.getPathTo({
        path: path,
        id: id
      }));
    }
  }, {
    key: "getImageData",
    value: function getImageData(_ref3, options) {
      var path = _ref3.path,
          id = _ref3.id;
      var securePath = this.getPathTo({
        path: path,
        id: id
      }) + '?' + options;
      return this._httpProvider.request({
        baseURL: this.baseUrl,
        url: securePath,
        headers: {
          'Content-Type': 'image/jpeg'
        }
      });
    }
  }, {
    key: "_send",
    value: function () {
      var _send2 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(_ref4) {
        var path, id, command, data, parseResponseDelegate, securePath, requestData, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                path = _ref4.path, id = _ref4.id, command = _ref4.command, data = _ref4.data, parseResponseDelegate = _ref4.parseResponseDelegate;
                securePath = this.getPathTo({
                  path: path,
                  id: id
                });
                requestData = command;

                if (data) {
                  requestData += ' ' + data;
                }

                _context.next = 6;
                return this._httpProvider.request({
                  method: 'POST',
                  baseURL: this.baseUrl,
                  url: securePath,
                  headers: {
                    'Content-Type': 'text/plain'
                  },
                  data: requestData
                });

              case 6:
                response = _context.sent;

                if (!parseResponseDelegate) {
                  _context.next = 11;
                  break;
                }

                _context.next = 10;
                return parseResponseDelegate(response.data);

              case 10:
                response.data = _context.sent;

              case 11:
                return _context.abrupt("return", response);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function _send(_x) {
        return _send2.apply(this, arguments);
      };
    }()
  }]);

  return ImageServerClient;
}(_BaseDataService2.BaseDataService);

exports.ImageServerClient = ImageServerClient;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/image-server/core/ImageServerClient.js
// module id = 254
// module chunks = 0